<template>
  <HorizolnalScroller
    ref="scroller"
    class="trainer-advanced-filter-overviwe traefilterover"
    :innerCssClass="`d-flex px-4`"
    style="
      --clr-arrow-back: var(--clr-black-1);
      --arrow-after-radius-left: 0 4px 4px 0;
      --arrow-after-radius-right: 4px 0 0 4px;
    "
  >
    <CustomFormatOption
      v-if="solElite.want_use && (solElite.loading_what || solElite.cTree)"
      :customTree="solElite.cTree"
      class="traefilterover_btn gw_btn-r1 gw_btn_outline weight_500 no-events"
    />
    <GameformatOption
      v-else
      :includeKeys="[
        'group',
        'format',
        'variant',
        'rake',
        'type_opening_size',
        'type',
        '_3bet_size',
      ]"
      :namespace="namespace"
      class="traefilterover_btn gw_btn-r1 gw_btn_outline weight_500 no-events"
    />
    <div
      v-if="depthList"
      class="traefilterover_btn gw_btn-r1 gw_btn_outline"
      @click="handleTabClick('depth_list')"
    >
      <span class="btn-title"> {{ $t('gameformat.stack') }}: </span>
      {{ depthList }}
      <i class="mdi ml-1 icon_btn pa-1 mdi-close text-normal"></i>
    </div>

    <div class="traefilterover_btn gw_btn-r1 gw_btn_outline no-events">
      <span class="btn-title"> {{ $t('common.start_spot') }}: </span>
      {{ $t(`common.${fh.fh_start_spot}`) }}
    </div>
    <div
      v-if="fh.fh_actions"
      class="traefilterover_btn gw_btn-r1 gw_btn_outline"
      @click="handleTabClick('actions')"
    >
      <span class="btn-title">
        {{
          $t('shortcut.street_action', {
            street: $t(`common.${fh.fh_start_spot}`),
          })
        }}:
      </span>
      {{ fh.actions }}
      <i class="mdi ml-1 icon_btn pa-1 mdi-close text-normal"></i>
    </div>
    <div
      v-if="fh.fh_hero"
      class="traefilterover_btn gw_btn-r1 gw_btn_outline"
      @click="handleTabClick('hero')"
    >
      <span class="btn-title"> {{ fh.singleHero ? $t(`common.hero`) : $t(`common.heros`) }}: </span>
      {{ fh.heros }}

      <i class="mdi ml-1 icon_btn pa-1 mdi-close text-normal"></i>
    </div>
    <div
      v-if="fh.fh_opponent"
      class="traefilterover_btn gw_btn-r1 gw_btn_outline"
      @click="handleTabClick('opponent')"
    >
      <span class="btn-title">
        {{ fh.singleOpponent ? $t(`common.opponent`) : $t(`common.opponents`) }}:
      </span>
      {{ fh.opponents }}

      <i class="mdi ml-1 icon_btn pa-1 mdi-close text-normal"></i>
    </div>
    <div
      v-if="fh.fh_alternate"
      class="traefilterover_btn gw_btn-r1 gw_btn_outline"
      @click="handleTabClick('fh_alternate')"
    >
      <span class="btn-title"> {{ $t(`shortcut.alternate_positions`) }}: </span>
      {{ $t(`btn.${fh.fh_alternate}`) }}
      <i class="mdi ml-1 icon_btn pa-1 mdi-close text-normal"></i>
    </div>
    <div
      v-if="fh.fh_rel_positions"
      class="traefilterover_btn gw_btn-r1 gw_btn_outline"
      @click="handleTabClick('fh_rel_positions')"
    >
      <span class="btn-title"> {{ $t(`shortcut.relative_hero_position`) }}: </span>
      {{ fh.fh_rel_positions }}

      <i class="mdi ml-1 icon_btn pa-1 mdi-close text-normal"></i>
    </div>
    <div
      v-if="fullBoard !== 'EeEeEeEeEe' || boardRules"
      class="traefilterover_btn gw_btn-r1 gw_btn_outline d-flex"
      @click="handleTabClick('board')"
    >
      <div class="mr-1 btn-title">{{ $t('common.board') }}:</div>
      <div v-if="fullBoard !== 'EeEeEeEeEe'">
        <CardRow
          size="mini"
          :cards="fullBoard"
        />
      </div>
      <div v-if="boardRules">{{ boardRules }} {{ $t('common.rules') }}</div>
      <i class="mdi ml-1 icon_btn pa-1 mdi-close text-normal"></i>
    </div>

    <div
      v-if="groups_selection !== 'only_cd' && (groups_selection === 'manual' ? manual : hand_class)"
      class="traefilterover_btn gw_btn-r1 gw_btn_outline"
      @click="handleTabClick(groups_selection)"
    >
      <span class="btn-title">
        {{
          groups_selection === 'manual'
            ? $t('common.hands')
            : $t(`trainer.groups_selection.${groups_selection}`)
        }}
      </span>
      {{ groups_selection === 'manual' ? manual : hand_class }}
      <i class="mdi ml-1 icon_btn pa-1 mdi-close text-normal"></i>
    </div>

    <div
      v-if="preferences"
      class="traefilterover_btn gw_btn-r1 gw_btn_outline"
      @click="handleTabClick('preferences')"
    >
      <span class="btn-title"> {{ $t('common.preferences') }}: </span>
      {{ preferences }}
      <i class="mdi ml-1 icon_btn pa-1 mdi-close text-normal"></i>
    </div>
  </HorizolnalScroller>
</template>

<script>
import CustomFormatOption from '@/components/GameFormat/CustomFormatOption'
import HorizolnalScroller from '@/components/HorizolnalScroller/HorizolnalScroller'
import GameformatOption from '@/components/GameFormat/GameFormatOption'
import { getFullBoardByStreet } from '@/helpers/cards'
import CardRow from '@/components/CardRow/CardRow'
import { getFullHandPreferencesOptions, getBoardFilterOptions } from '@/store/router/router'
import format_mix from '@/mixins/format_mix'
import horizontalScroll_mix from '@/components/HorizolnalScroller/horizontalScroll_mix'
import { numRoundTo5bb } from '@/helpers/helpers'

export default {
  name: 'TrainerAdvancedFilterOverview',
  components: {
    GameformatOption,
    CardRow,
    CustomFormatOption,
    HorizolnalScroller,
  },
  mixins: [format_mix, horizontalScroll_mix],
  props: {
    namespace: { String, required: true },
    solElite: Object,
  },
  methods: {
    updateQuery(query) {
      this.$store.dispatch(`${this.namespace}/router_update_query`, {
        query,
        push: false,
        replace: false,
        saveLocally: false,
      })
    },
    handleTabClick(tab) {
      let query = {}
      if (tab === 'actions') {
        query = { fh_actions: [] }
      }
      if (tab === 'hero') {
        query = { fh_hero: [] }
      }
      if (tab === 'opponent') {
        query = { fh_opponent: [] }
      }
      if (tab === 'fh_alternate') {
        query = { fh_alternate: [] }
      }
      if (tab === 'board') {
        const rules = getBoardFilterOptions()
        const params = {}
        Object.keys(rules).forEach(key => {
          params[key] = []
        })
        query = { board: '', ...params }
      }
      if (tab === 'manual') {
        query = { fh_groups: [] }
      }
      if (tab === 'hand_class') {
        query = {
          fh_hands: [], //
          fh_draws: [],
        }
      }
      if (tab === 'preferences') {
        const rules = getFullHandPreferencesOptions()
        const params = {}
        Object.keys(rules).forEach(key => {
          params[key] = []
        })
        query = {
          ...params,
          fh_trainer_mode: rules.fh_trainer_mode[0],
          fh_trainer_game_mode: rules.fh_trainer_game_mode[0],
        }
      }
      if (tab === 'depth_list') {
        query = { depth_list: [] }
      }
      if (tab === 'fh_rel_positions') {
        query = { fh_rel_positions: [] }
      }
      this.updateQuery(query)
    },
  },
  computed: {
    qqfh() {
      return this.$store.getters[`${this.namespace}/query_fullhand_setup`]
    },
    fh() {
      const { qqfh } = this
      const fh = {}
      Object.keys(qqfh).forEach(key => {
        fh[key] = qqfh[key].split(',').filter(i => i)
      })

      const flopPreflop = qqfh.fh_start_spot.includes('flop')
      const res = {
        fh_start_spot: qqfh.fh_start_spot,
        fh_hero: flopPreflop ? qqfh.fh_hero : '',
        fh_opponent: flopPreflop ? qqfh.fh_opponent : '',
        fh_actions: flopPreflop ? qqfh.fh_actions : '',
        actions: fh.fh_actions.map(a => this.$t(`shortcut.${a}`)).join(', '),
        heros: fh.fh_hero.map(a => this.$t(`players.${a}`)).join(', '),
        singleHero: fh.fh_hero.length < 2,
        opponents: fh.fh_opponent.map(a => this.$t(`players.${a}`)).join(', '),
        singleOpponent: fh.fh_opponent.length < 2,
        fh_rel_positions: fh.fh_rel_positions.map(a => a).join(', '),
        fh_alternate: qqfh.fh_alternate,
      }
      // console.log(res)
      return res
    },
    fullBoard() {
      let res = this.$store.getters[`${this.namespace}/query_board`]
      res = getFullBoardByStreet(res, 'river')
      return res
    },
    groups_selection() {
      const { qqfh } = this
      return qqfh.fh_groups_selection || 'manual'
    },
    manual() {
      const { qqfh } = this
      let res = qqfh.fh_groups.split(',').filter(i => i)
      res = res.length
      return res
    },
    hand_class() {
      const { qqfh } = this
      const hands = qqfh.fh_hands.split(',').filter(i => i)
      const draws = qqfh.fh_draws.split(',').filter(i => i)
      return hands.length + draws.length
    },
    preferences() {
      const { qqfh } = this
      const conf = getFullHandPreferencesOptions()
      let res = 0
      Object.keys(conf).forEach(key => {
        const rules = qqfh[key].split(',').filter(i => i)
        res += rules.length
      })
      return res - 2
    },
    depthList() {
      const query_gameformat = this.$store.getters[`${this.namespace}/query_gameformat`]
      const res = query_gameformat.depth_list
        .split(',')
        .filter(i => i)
        .map(i => numRoundTo5bb(Number(i)))
        .join(',')
      return res
    },
    boardRules() {
      const query_board_filter = this.$store.getters[`${this.namespace}/query_board_filter`]
      const conf = getBoardFilterOptions()
      let res = 0
      Object.keys(conf).forEach(key => {
        const rules = query_board_filter[key].split(',').filter(i => i)
        res += rules.length
      })
      return res
    },
    handler() {
      return this.item?.handler
    },
    status() {
      return this.item?.status
    },
  },
  watch: {
    fh() {
      if (this.$refs.scroller) {
        this.$refs.scroller.checkOverflow()
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.traefilterover {
  display: flex;
  max-width: 100vw;
  height: 3rem;
  flex-shrink: 0;
  --clr-back: var(--clr-black-1-2);
  background: var(--clr-back);
  grid-gap: 0.25rem;
  --clr-back-btn: var(--clr-black-3);
  overflow: hidden;
  position: relative;
  &_inner {
    padding: 0 1rem;
  }
  &_btn {
    margin: auto 0.125rem;
    white-space: nowrap;
    font-size: 0.8rem;
    flex-shrink: 0;
    .btn-title {
      font-weight: 700;
      margin-right: 0.25rem;
    }
    &:hover {
      --clr-back-btn: var(--clr-black-4);
    }
  }
}
</style>
